import api from '../../../../api/api'
import url from '../../../../api/env'
import Utils from '../../../../utils/Utils'

const getAllDiscounts = async () =>
  api
    .get(`${url.stage.discounts_options}?paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getDiscounts = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.discounts}?sort_type=${sort_type}&per_page=${pageNumber}&discount_level=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.discounts}?per_page=${pageNumber}&discount_level=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newDiscounts = async data =>
  api
    .post(url.stage.discounts, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editDiscounts = async (stateId, data) =>
  api
    .put(`${url.stage.discounts}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeDiscounts = async stateId =>
  api
    .remove(`${url.stage.discounts}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getDiscounts,
  newDiscounts,
  editDiscounts,
  removeDiscounts,
  getAllDiscounts
}
